// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database"; // Import getDatabase

const firebaseConfig = {
  apiKey: "AIzaSyAdhUfWa-6Y1sbM41foIqpoafHhUwYgRbA",
  authDomain: "ishamswedding.firebaseapp.com",
  databaseURL: "https://ishamswedding-default-rtdb.firebaseio.com",
  projectId: "ishamswedding",
  storageBucket: "ishamswedding.firebasestorage.app",
  messagingSenderId: "342954020845",
  appId: "1:342954020845:web:68bc3e79ddec7d6351a1e4",
  measurementId: "G-5G9VYGV82G",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getDatabase(app); // Initialize Realtime Database

export { app, analytics, db };

